import './index.css';

export default {
  name: 'AseamlessScroll',
  props: {
    id: { type: String, default: () => (`a-seamless-scroll-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 3000 }, // 滚动速度(值越小越快)
    pause: { type: Boolean, default: () => false }, // 是否暂停
    horizontal: { type: Boolean, default: () => false }, // 水平方向
  },
  data() {
    return ({
      stop: this.pause,
      height: null,
      position: null,
      animation: null,
      scrollHeight: null,
    });
  },
  watch: {
    pause(state) {
      this.stop = state;
      this.$nextTick(() => this.enable());
    },
  },
  computed: {
    style() {
      return ({ transform: (`translate${this.horizontal ? 'X' : 'Y'}(${-this.position}px)`) });
    },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.revoke();
      this.$nextTick(() => {
        !this.height && (this.height = Math.floor(this.$el.clientHeight));
        this.$nextTick(() => {
          const body = this.$refs.aSeamlessScrollBody;
          if (body) {
            !this.scrollHeight && (this.scrollHeight = Math.floor((this.horizontal ? body.clientWidth : body.clientHeight) / 2));
            this.$nextTick(() => this.enable());
          }
        });
      });
    },
    moving() {
      this.position += Math.min((1000 / parseInt(this.speed)), 5);
      if (this.position >= this.scrollHeight) {
        this.position = 0;
      }
      this.$nextTick(() => this.$emit('moving', this.position));
    },
    enable() {
      if (this.animation) {
        this.cancel();
      } else if (this.stop === false) {
        const animation = () => {
          this.moving();
          this.$nextTick(() => this.animation = requestAnimationFrame(animation));
        }
        animation();
      }
    },
    cancel() {
      if (this.animation) {
        cancelAnimationFrame(this.animation);
        this.animation = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => {
        this.height = null;
        this.position = null;
        this.scrollHeight = null;
      });
    },
  },
  render() {
    const { width = '100%', height = '100%', padding, margin } = this.$attrs;
    return this.$slots.default && (
      <div
        id={this.id}
        on-mouseenter={this.cancel}
        on-mouseleave={this.enable}
        style={{ width, height, padding, margin }}
        class={['a-seamless-scroll', (this.horizontal ? 'horizontal' : null)]}
      >
        <div class="a-seamless-scroll-main" style={{ height: `${this.height}px` }}>
          {this.height && (
            <div ref="aSeamlessScrollBody" class="a-seamless-scroll-body" style={this.style}>
              <div>{this.$slots.default}</div>
              <div>{this.$slots.default}</div>
            </div>
          )}
        </div>
      </div>
    );
  },
}